import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";

const initialState : {
    employeeDict: {},
    employeeFieldIdDict: {},

    status: APIRequestStatus,
    error: string | null,
} = {
    employeeDict: {},
    employeeFieldIdDict: {},

    status: APIRequestStatus.Idle,
    error: null
}

export const fetchEmployeeList = createAsyncThunk('employeeDict/fetchEmployeeList', async () => {
    const response = await axios({
        method: 'get',
        url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/employee',
    });
    return response.data
})

export const updateEmployee = createAsyncThunk('employeeDict/updateEmployee', async (arg: {
    employeeId: string,
    division?: string,
    tunjanganDivisionId?: string,
    isActive?: boolean,
    isPresent?: boolean,
    targetPoints?: number
    }, thunkAPI) => {
    const response = await axios({
        method: 'post',
        url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/employee-update',
        data: {body: JSON.stringify(arg)}
    })

    return response.data
})

export const addEmployee = createAsyncThunk('employeeDict/addEmployee', async (arg: {name: string, fieldId: string}, thunkAPI) => {
    const payload: any = {
        name: arg.name,
        fieldId: arg.fieldId,
    };
    
    const response = await axios({
        method: 'post',
        url: "https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/employee",
        data: {
            body: JSON.stringify(payload)
        },
    });
    console.log(response);

    thunkAPI.dispatch(fetchEmployeeList());

    return response.data;
})

export const employeeDictSlice = createSlice({
    name: 'employeeDict',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
      builder
        .addCase(fetchEmployeeList.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(fetchEmployeeList.fulfilled, (state, action) => {
            const empDict = {};
            for (let obj of (action.payload.employeeList ?? [])) {
                empDict[obj.employeeId] = obj;
            }
            state.employeeDict = empDict;
            const empFieldDict = {};
            for (let obj of (action.payload.employeeFieldIdList ?? [])) {
                empFieldDict[obj.employeeId] = obj;
            }
            state.employeeFieldIdDict = empFieldDict;

            state.status = APIRequestStatus.Success;
        })
        .addCase(fetchEmployeeList.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            // state.error = action.error.message
            console.log("fetch is failure");
        })
        .addCase(updateEmployee.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(updateEmployee.fulfilled, (state, action) => {
            state.status = APIRequestStatus.Success;
            
            const updatedData = action.meta.arg;
            const { employeeId } = updatedData;

            if (state.employeeDict[employeeId]) {
                state.employeeDict[employeeId] = {
                    ...state.employeeDict[employeeId],
                    ...updatedData
                };
            }
        })
        .addCase(updateEmployee.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
        })
        .addCase(addEmployee.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(addEmployee.fulfilled, (state, action) => {
            state.status = APIRequestStatus.Success;
        })
        .addCase(addEmployee.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
        })
    }
})

export default employeeDictSlice.reducer